import React from 'react';
import { Route, Switch } from 'react-router';
import { logisticaMenuRoutes } from '../constants';



export const LogisticaMenuRoutes = () => {

  return (
		<Switch>
			{
				[logisticaMenuRoutes.map((route, index) => {
					return (
						<Route 
							key={index}
							path={route.path}
							exact={route.exact}
							render={() => <route.component />} />													
					)
					})					
				]
			}
		</Switch>
	);
}
